import React from "react";
import ShopList from "../Components/ShopList";

function ShopListScreen() {

  return (
    <div>
      <ShopList />
    </div>
  );
}

export default ShopListScreen;
